module.exports = __webpack_public_path__ + "img/Entia-Lineas-de-transmision-distribucion-electrica-4.bae6f050.webp";